import React, { useState } from "react";
import { useEffect } from "react";
import BootstrapTable from 'react-bootstrap-table-next';
import filterFactory, { textFilter } from 'react-bootstrap-table2-filter';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import 'react-bootstrap-table2-filter/dist/react-bootstrap-table2-filter.min.css';
import { docLinkFormatter, formatDateTime } from "../helpers/helperFunctions";
import ExpandIcon from '../images/increase-size-option.png'
import PopUpComponent from "./PopUpComponent";











const TableComponent = ({data}) =>{

    const [itemData, setItemData] = useState([])

useEffect(()=>{

    let tempItems = []

    data.forEach(element => {
        let tempObj = {...element.fields, 'id':element.id}
        tempItems.push(tempObj)
        
    });

    setItemData(tempItems)

},[data])


// column formatters
const dateTimeFormatter = (cell)=>{

  return (
    <span>
     {formatDateTime(cell)}
    </span>
  );


}

const slNoFormatter = (cell, row, index)=>{

return <span>{index+1} <img title="Expand Record" role="button" className="float-right" src={ExpandIcon} alt="expand" onClick={()=>expandAction(row)} /></span>

}


const columns = [
  {
    dataField: 'id',
    text: '#',
  formatter: slNoFormatter,
    
    style: {
     
      fontSize:'14px',
      width: '5%',
    
    },
    headerStyle: {
      fontSize:'14px',
     
    },
   
  },
  {
    dataField: 'District',
    text: 'District',
    sort: true,
     filter: textFilter({
      style: {
          fontSize:'14px'
        },
    }),
    style: {
      width: '15%',
      
      fontSize:'14px'
    
    },
    headerStyle: {
      fontSize:'14px'
    }
  },
 {
  dataField: 'Member Name(s)',
  text: 'Member Name(s)',
  sort: true,
   filter: textFilter({
    style: {
        fontSize:'14px'
      },
  }),
  style: {
   
    
    fontSize:'14px',
    width:'20%'
  
  },
  headerStyle: {
    fontSize:'14px'
  }
}, 
{
  dataField: 'Notes',
  text: 'Notes',
  sort: true,
   filter: textFilter({
    style: {
        fontSize:'14px',
       
      },
  }),
  style: {

    
    fontSize:'14px',
    width:'25%'
  
  },
  headerStyle: {
    fontSize:'14px'
  }
},
{
  dataField: 'Date Time',
  text: 'Date Time',
  formatter: dateTimeFormatter,
  sort: true,
  style: {
    
    
    fontSize:'14px',
    width:'10%'
  
  },
  headerStyle: {
    fontSize:'14px'
  },
 
},
{
  dataField: 'Representative/Senator',
  text: 'Representative/Senator',
  sort: true,
   filter: textFilter({
    style: {
        fontSize:'14px'
      },
  }),
  style: {
   
    
    fontSize:'14px',
    width:'10%'
  
  
  },
  headerStyle: {
    fontSize:'14px'
  }
},
{
  dataField: 'Office Location',
  text: 'Office Location',
  sort: true,
   filter: textFilter({
    style: {
        fontSize:'14px'
      },
  }),
  style: {
    
    
    fontSize:'14px',
    width:'10%'
  
  },
  headerStyle: {
    fontSize:'14px'
  }
},
{
  dataField: 'Talking Points Documents',
  text: 'Talking Points Documents',
  formatter: docLinkFormatter,
  sort: false,
  style: {
    
    
    fontSize:'14px',
    
  
  },
  headerStyle: {
    fontSize:'14px'
  }
},


];

const expandAction = (data) =>{
setRowData(data)
setExpand(true)


}

const settings = {
  responsive: [
    {
      breakpoint: 1024,
      
    },
    {
      breakpoint: 768,
     
    },
    {
      breakpoint: 480,
     
    },
  ],

}


const [expand, setExpand] = useState(false)
const [rowData, setRowData] = useState({})

    return  <div className="py-5 mb-5 table-container">
 <BootstrapTable 
 
 keyField='id' 
 data={ itemData } 
 columns={ columns }
 {...settings}
 striped
 bootstrap4
 condensed
 filter={ filterFactory()}
 filterPosition="top"
 
 classes="table-responsive"
 />
    <PopUpComponent visible={expand} data = {rowData} onCollapse={()=>{setRowData({}); setExpand(false)}} />
    </div>
   


}

export default TableComponent